import { DatePipe } from "@angular/common";
import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { Router } from "@angular/router";
import { User } from "../../../Modals/user.model";
import { AuthService } from "../../common/services/auth.service";
import { FormService } from "../../common/services/form.service";
import { ModalService } from "../../common/services/modal.service";

@Component({
    selector: "app-register",
    templateUrl: "./register.component.html",
    styleUrls: ["./register.component.scss"],
})
export class RegisterComponent implements OnInit, AfterViewInit {
    user: User = new User();
    dateOfBirth: Date;
    @ViewChild("registerForm") registerForm: NgForm;
    forms: NgForm[] = [];
    passwordConfirmation: string = "";
    loading: boolean = false;

    constructor(
        private authService: AuthService,
        private formService: FormService,
        private modal: ModalService,
        private datepipe: DatePipe,
        private router: Router
    ) {}

    ngOnInit(): void {}

    ngAfterViewInit(): void {
        this.forms.push(this.registerForm);
    }

    register() {
        if (this.loading) return;
        if (this.user.password !== this.passwordConfirmation) {
            this.modal.snackMessage("check the password confirmation");
            return;
        }
        let isValid = this.formService.validateForm(this.forms);

        if (!isValid) {
            this.modal.openValidationDialog(
                "warning",
                "خطأ",
                "يرجي ملئ البيانات المطلوبه"
            );
            return;
        }

        this.loading = true;
        let latest_date = this.datepipe.transform(
            this.dateOfBirth,
            "yyyy-MM-dd"
        );
        this.user.dateofbirth = latest_date;

        this.authService.register(this.user).subscribe(
            (res) => {
                console.log(res);
                this.loading = false;
                if (res["success"] == false) {
                    this.modal.snackMessage(res["message"]);
                    return;
                } else {
                    this.modal.snackMessage(res["message"]);
                    this.authService.saveToken(res["data"]["token"]);
                        localStorage.setItem("userID", res["data"]["id"]);
                    this.router.navigate(["/"]);
                }
            },
            (error) => {
                this.loading = false;
                this.modal.snackMessage(error["error"].error);
            }
        );
    }
}
